import React from "react";
import Table from "../DataTable";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import ManagePriceModal from "./ManagePricingModal";
import ActionImageButton from "../DataTable/ActionImageButton";
import { TableWithPagination } from "../TableWithPagination";

interface PrecisionPricingProps {
  data: any[];
  onManagePriceClick: any;
  formModal: boolean;
  formData: any;
  onPriceFormSubmit: any;
  onPricingFormChange: any;
  products: any;
  errors: any;
  fetchLoader: any;
  addLoader: any;
  onEditClick: any;
  isEdit: any;
  page: any;
  limit: any;
  onPageChange: any;
  totalData: any;
}

const PrecisionPricing: React.FC<PrecisionPricingProps> = ({
  data,
  onManagePriceClick,
  formData,
  formModal,
  onPriceFormSubmit,
  onPricingFormChange,
  products,
  errors,
  fetchLoader,
  addLoader,
  onEditClick,
  isEdit,
  page,
  limit,
  onPageChange,
  totalData,
}) => {
  const columns = [
    { label: "Outlet Shortname", path: "outletShortName" },
    { label: "Date", path: "date" },
    { label: "Product Code", path: "productCode" },
    { label: "Product ID", path: "productId" },
    { label: "Price", path: "price" },
    {
      label: "Action",
      content: (outlet: { id: number | string | any }) => (
        <ActionImageButton
          onClick={() => onEditClick(outlet)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label="Edit Berth"
        />
      ),
    },
  ];
  return (
    <div
      style={{
        display: "flex",
        gap: "1.5rem",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <Button
        width="160px"
        variant="filled"
        label="Add Pricing"
        color={Colors.red}
        onClick={() => onManagePriceClick(true)}
        disabled={fetchLoader || addLoader}
      />
      <div style={{ width: "100%" }}>
        <TableWithPagination
          data={data}
          columns={columns}
          currentPage={page}
          totalData={totalData}
          rowsPerPage={limit}
          onPageChange={onPageChange}
        />
      </div>
      {formModal && (
        <ManagePriceModal
          onToggleModalState={onManagePriceClick}
          data={formData}
          onPricingFormChange={onPricingFormChange}
          onPriceFormSubmit={onPriceFormSubmit}
          errors={errors}
          products={products}
          fetchLoader={fetchLoader}
          addLoader={addLoader}
          isEdit={isEdit}
        />
      )}
    </div>
  );
};

export default PrecisionPricing;
